export interface FeatureFlagsState {
  'enrollments-ug-enable-county-field'?: boolean;
}

const featureFlags: FeatureFlagsState = {
  'enrollments-ug-enable-county-field': undefined,
};

export default featureFlags;
